const mEditionProductAutorespondersLists = {
  mEditionProductAutorespondersLists: {
    buttonSecondary: {
      associateAutoresponderText: 'Asociar Cuenta',
      associateAutoresponderListText: 'Asociar Lista'
    },

    quote: {
      firstTextAutoresponders: 'Aún no tienes cuentas de autoresponders asociadas a tu academia.',
      secondTextAutoresponders: 'Primero asocia una o más cuentas y luego podrás asociar sus listas a la registración o compra de tu producto.',
      firstTextAutorespondersLists: 'Aún no tienes listas de autoresponders asociadas a tu producto.',
      secondTextAutorespondersLists: 'Al asociar una lista de autoresponder podrás almacenar y segmentar en grupos los diferentes emails de las personas que se registren o compren tu producto.'
    },

    table: {
      thAccount: 'Cuenta',
      thAutoresponder: 'Autoresponder',
      thDelete: 'Eliminar',
      thList: 'Lista'
    },

    tooltip: {
      delete: 'Eliminar Lista'
    }
  }
}

export default mEditionProductAutorespondersLists
